import { schema } from "normalizr";
import Entry from "./catalog-entry";

export default new schema.Array(Entry);
